import React, { useState } from 'react';
import { PhaseDiscussion } from './PhaseDiscussion';
import { PhaseCards } from './PhaseCards';
import { PhaseChallenge } from './PhaseChallenge';
import { PhaseSummary } from './PhaseSummary';
import { ArrowLeftIcon, ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export function Game({
  phases,
  currentPhase,
  team,
  onCompletePhase
}) {
  const [phaseStep, setPhaseStep] = useState('main'); // 'main', 'summary'
  const [phaseSummary, setPhaseSummary] = useState('');
  const currentPhaseData = phases[currentPhase];
  const handleCompletePhase = summary => {
    setPhaseSummary(summary);
    setPhaseStep('summary');
  };
  const submitPhaseAndContinue = () => {
    onCompletePhase(currentPhaseData.id, phaseSummary);
    setPhaseStep('main');
    setPhaseSummary('');
  };
  const renderPhaseContent = () => {
    if (phaseStep === 'summary') {
      return <PhaseSummary phaseName={currentPhaseData.name} summary={phaseSummary} onSubmit={submitPhaseAndContinue} data-id="element-110" />;
    }
    switch (currentPhaseData.type) {
      case 'discussion':
        return <PhaseDiscussion phase={currentPhaseData} team={team} onComplete={handleCompletePhase} data-id="element-111" />;
      case 'cards':
        return <PhaseCards phase={currentPhaseData} team={team} onComplete={handleCompletePhase} data-id="element-112" />;
      case 'challenge':
        return <PhaseChallenge phase={currentPhaseData} team={team} onComplete={handleCompletePhase} data-id="element-113" />;
      default:
        return <div data-id="element-114">Unknown phase type</div>;
    }
  };
  return <div className="w-full min-h-screen p-4 md:p-6" data-id="element-115">
      <header className="mb-6" data-id="element-116">
        <h1 className="text-3xl font-bold text-indigo-800 text-center" data-id="element-117">
          Bridges of Life
        </h1>
        <div className="mt-6 bg-white rounded-xl shadow-lg p-4" data-id="element-118">
          <div className="flex justify-between items-center mb-4" data-id="element-119">
            <h2 className="text-xl font-semibold" data-id="element-120">Game Progress</h2>
            <div className="text-sm text-gray-500" data-id="element-121">
              Phase {currentPhaseData.id} of {phases.length}
            </div>
          </div>
          <div className="relative" data-id="element-122">
            <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-gray-200" data-id="element-123">
              <div className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-600" style={{
              width: `${currentPhaseData.id / phases.length * 100}%`
            }} data-id="element-124"></div>
            </div>
            <div className="flex justify-between" data-id="element-125">
              {phases.map((phase, index) => <div key={phase.id} className={`w-10 h-10 rounded-full flex items-center justify-center ${index < currentPhase ? 'bg-indigo-600 text-white' : index === currentPhase ? 'bg-indigo-100 border-2 border-indigo-600 text-indigo-800' : 'bg-gray-200 text-gray-500'}`} data-id="element-126">
                  {phase.completed ? <CheckCircleIcon className="w-5 h-5" data-id="element-127" /> : phase.id}
                </div>)}
            </div>
            <div className="flex justify-between mt-2 text-xs text-gray-500" data-id="element-128">
              {phases.map(phase => <div key={phase.id} className="w-10 text-center overflow-hidden" data-id="element-129">
                  {phase.name}
                </div>)}
            </div>
          </div>
        </div>
      </header>
      <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 mb-6" data-id="element-130">
        <div className="flex items-center justify-between mb-4" data-id="element-131">
          <h2 className="text-2xl font-bold text-indigo-800" data-id="element-132">
            {currentPhaseData.name}
          </h2>
          <div className="px-3 py-1 rounded-full bg-indigo-100 text-indigo-800 text-sm" data-id="element-133">
            {currentPhaseData.type.charAt(0).toUpperCase() + currentPhaseData.type.slice(1)}
          </div>
        </div>
        {renderPhaseContent()}
      </div>
      <div className="flex justify-between mt-6" data-id="element-134">
        <button className="px-4 py-2 flex items-center text-indigo-600 hover:text-indigo-800 disabled:text-gray-400" disabled={currentPhase === 0} data-id="element-135">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-136" />
          Previous Phase
        </button>
        <button className="px-4 py-2 flex items-center text-indigo-600 hover:text-indigo-800 disabled:text-gray-400" disabled={currentPhase === phases.length - 1 || phaseStep === 'summary'} data-id="element-137">
          Skip to Next
          <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-138" />
        </button>
      </div>
    </div>;
}